<div class="cp-shell">
  <div class="container">

  <!-- HEADER -->
  <div class="cp-header">
    <div class="cp-title-block">
      <div class="icon-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      </div>
      <div class="title-text">
        <h1>Conferência Pendente</h1>
        <p>Pedidos aguardando ajuste do vendedor</p>
      </div>
    </div>
    <label class="toggle-ver-todos">
      <input type="checkbox" [(ngModel)]="verTodos" (ngModelChange)="buscarPedidos(true)">
      Ver todos os vendedores
    </label>
    <button class="btn-refresh" (click)="buscarPedidos(true)" title="Atualizar">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></svg>
    </button>
  </div>

  <!-- LOADING -->
  <div *ngIf="carregando" class="loading-state">
    <app-loading-indicator></app-loading-indicator>
    <span>Carregando pendências...</span>
  </div>

  <!-- ERRO -->
  <div *ngIf="erro && !carregando" class="error-state">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    <p>{{ erro }}</p>
  </div>

  <!-- VAZIO -->
  <div *ngIf="!carregando && !erro && pedidos.length === 0" class="empty-state">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
    <p>Nenhuma pendência no momento</p>
  </div>

  <!-- GRID DE CARDS -->
  <div *ngIf="!carregando && !erro && pedidos.length > 0" class="pedidos-grid">
    <div class="pedido-card" *ngFor="let p of pedidos">

      <div class="card-header">
        <span class="nunota-badge">#{{ p.nunota }}</span>
        <span class="badge-imediato" *ngIf="p.imediato === 'S'">Imediato</span>
        <span class="badge-prioridade" *ngIf="p.prioridade === 'S'">Prioridade</span>
        <span class="prefixo-badge" *ngIf="p.prefixo">{{ p.prefixo }}</span>
      </div>

      <div class="card-body">
        <div class="cliente-nome">{{ p.nomeCliente }}</div>
        <div class="card-meta">
          <span class="meta-label">Vendedor</span>
          <span class="meta-val">{{ p.vendedor }}</span>
        </div>
        <div class="card-meta">
          <span class="meta-label">Conferente</span>
          <span class="meta-val">{{ p.confNome || '—' }}</span>
        </div>
        <div class="card-meta">
          <span class="meta-label">Enviado em</span>
          <span class="meta-val">{{ p.dtEnvio || '—' }}</span>
        </div>
      </div>

      <div class="card-pendencia-bar">
        <div class="pendencia-info">
          <span class="pend-count">{{ p.qtdPendentes }}</span>
          <span class="pend-label">{{ p.qtdPendentes === 1 ? 'item pendente' : 'itens pendentes' }} de {{ p.totalItens }}</span>
        </div>
        <div class="pend-bar">
          <div class="pend-fill" [style.width.%]="100 - (p.qtdPendentes / p.totalItens * 100)"></div>
        </div>
      </div>

      <div class="card-footer">
        <button class="btn-ver-itens" (click)="abrirItens(p)">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          Ver Itens Pendentes
        </button>
      </div>

    </div>
  </div>

  </div>
</div>
